import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "excel-edit-editor"
}
const _hoisted_2 = { class: "info-language-section" }
const _hoisted_3 = { class: "language-selection" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "info-area" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "attribute-group-section"
}
const _hoisted_7 = { class: "attribute-group" }
const _hoisted_8 = { class: "hint" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdp-Info" })
], -1)
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "export-selection-section" }
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = { class: "export-selection-section-content" }
const _hoisted_14 = { class: "selection-area" }
const _hoisted_15 = { class: "general" }
const _hoisted_16 = { class: "attributes" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row-filler" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "filler-area" }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "mam-section-selection"
}
const _hoisted_20 = { class: "mam-section-selection-content" }
const _hoisted_21 = {
  key: 2,
  class: "erp-section-selection"
}
const _hoisted_22 = { class: "erp-section-selection-content" }
const _hoisted_23 = { class: "action-result-section" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "warning-entry-container" }
const _hoisted_26 = { class: "upload-section" }
const _hoisted_27 = ["onDrop"]
const _hoisted_28 = { class: "is-dropping-content" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "cil-cloud-upload" })
], -1)
const _hoisted_30 = { class: "text" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "cil-cloud-upload" })
], -1)
const _hoisted_32 = { class: "text" }
const _hoisted_33 = ["accept"]
const _hoisted_34 = {
  key: 1,
  class: "uploaded-content"
}
const _hoisted_35 = { class: "icon" }
const _hoisted_36 = {
  key: 0,
  class: "mdp-FileExcel"
}
const _hoisted_37 = {
  key: 1,
  class: "cil-report"
}
const _hoisted_38 = { class: "name" }
const _hoisted_39 = { class: "action-area mt-2" }
const _hoisted_40 = {
  key: 0,
  class: "error-area"
}

import { Typeguards } from "@/util/typeguards";
import { AttributeDataTypes } from "@AttributeManager/configurations/AttributeTypeDataTypes";
import Alert from "@common/components/Alert.vue";
import Dropdown from "@common/components/Dropdown.vue";
import Spinner from "@common/components/Spinner.vue";
import { useToast } from "@common/composable/toast";
import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { useLicenses } from "@common/composable/useRootStore";
import { ERPSection, ExportSelection, ExportWarnings, Selectable } from "@medapro-types/ContentEditor/Components/ExcelEditEditor";
import { CatalogNodeState } from "@medapro-types/ContentEditor/content-editor-store";
import type { LocalizedLanguage, MAMDetails } from "@medapro-types/common/common";
import { MetaDataState } from "@medapro-types/common/metadata";
import { RootState } from "@medapro-types/common/rootstate";
import { ActivityCriteria, ExcelEditAttributeGroups, ExcelExportArgs } from "@medapro-types/services/excelEdit";
import eventLogger from "@services/ApiLogger/EventLogger.js";
import activityApi from "@services/activity";
import apps from "@services/applications";
import automationServerApi from "@services/automationServer";
import endpoints from "@services/endpoints";
import erpSectionsApi from "@services/erpSections.js";
import excelEditApi from "@services/excelEdit";
import mediaAssetsApi from "@services/mediaAssets.js";
import { BaseIds } from "@util/enums/base-ids";
import { Guid } from "@util/guid";
import { naturalSort } from "@util/naturalSort";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import emitter from "tiny-emitter/instance";
import { Ref, computed, onMounted, reactive, ref, watch, onBeforeUnmount } from "vue";
import { useI18n } from "vue-i18n";
import { createNamespacedHelpers, useState } from "vuex-composition-helpers";
import ExportProgressModal from "./ExportProgressModal.vue";
import { useFiles } from "@common/composable/useFiles";

//#region General
type ViewModel = {
  selectedLanguage: string;
  attributeGroups: Array<ExcelEditAttributeGroups>;
  selectedAttributeGroup?: string | null;
  exportSelection: Record<ExportSelection, Selectable>;
  includeUnits: boolean;
  MAMDetails: MAMDetails | undefined;
  uploadedFile: File | null;
  isDroping: boolean;
  isExportProgress: boolean;
  modalShow: boolean;
  warnings: ExportWarnings;
  errors?: string;
  showExportSuccessAlert: boolean;
  showImportSuccessAlert: boolean;
  languages: Array<LocalizedLanguage>;
  exportIsCanceled: boolean;
  abortController: AbortController | null;
  hasUnsavedData: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ExcelEditEditor',
  props: {
    isAdvancedSearchExcelEdit: { type: Boolean },
    advancedSearchId: {},
    advancedSearchName: {},
    advancedSearchCatalogId: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const { t: $t } = useI18n();
const { createToast } = useToast();
const { triggerFileDownloadViaEndpoint } = useFiles();
//#endregion

//#region Store

///contentEditor/catalogNode
const { userSettings, globalParameters } = useState<RootState>(["userSettings", "globalParameters"]);
const { checkForLicensed } = useLicenses();
const { useState: useCatalogNodeState } = createNamespacedHelpers<CatalogNodeState>("contentEditor/catalogNode");
const { path } = useCatalogNodeState(["path"]);

///Metadata
const { useState: useMetaDataState } = createNamespacedHelpers<MetaDataState>("metadata");
const { contentLanguages } = useMetaDataState(["contentLanguages"]);
//#endregion

//#region Computed Store Value
const primaryLanguageCode = computed(() => contentLanguages.value.enabled[0].languageCode);
const { localizedLanguages } = useContentLanguages();

const catalogId = computed<string>(() => {
  return path.value[0].nodeId;
});

const currentNodeId = computed<string>(() => {
  return _.last(path.value).nodeId;
});
const currentNodeName = computed<string>(() => {
  return _.last(path.value).name;
});

//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({
  selectedLanguage: primaryLanguageCode.value,
  attributeGroups: [],
  selectedAttributeGroup: null,
  exportSelection: {
    masterData: { name: "MasterData", selected: true },
    alternativeArticleNo: { name: "AlternativeArticleNos", selected: true },
    mediaAssets: { name: "MediaAssets", selected: true },
    keywords: { name: "Keywords", selected: true },
    classification: { name: "Classifications", selected: true },
    references: { name: "References", selected: true },
    prices: { name: "Prices", selected: true },
    globalAttributes: { name: "GlobalAttributes", selected: true },
    erpAttributes: { name: "ErpSections", selected: true },
    textAttributes: { name: "InvariantAttributes", selected: true },
    tableAttributes: { name: "VariantAttributes", selected: true },
    gpsr: { name: "GPSR", selected: true }
  },
  includeUnits: true,
  MAMDetails: undefined,
  isDroping: false,
  uploadedFile: null,
  isExportProgress: true,
  modalShow: false,
  warnings: {},
  errors: undefined,
  showExportSuccessAlert: false,
  showImportSuccessAlert: false,
  languages: [],
  exportIsCanceled: false,
  abortController: null,
  hasUnsavedData: false
});
//#endregion

//#region Language Selection

const languageList = computed(() => {
  return localizedLanguages.value.map((x) => {
    return { key: x.languageCode, name: x.localizedName };
  });
});
//#endregion


//#region Attribute Group Selection

const hasMultipleAttributeGroups = computed(() => {
  return _.filter(vm.attributeGroups, (x) => !!x.attributeGroupId)?.length > 1;
});

//#endregion

//#region MAM-Section-Selection
const allMAMSectionsSelected = computed(() => {
  return !_.some(mamSectionSelectionList.value, { selection: false });
});
const noneMAMSectionsSelected = computed(() => {
  return !_.some(mamSectionSelectionList.value, { selection: true });
});
const selectedMAMSectionString = computed(() => {
  if (noneMAMSectionsSelected.value) {
    return `<${$t("none")}>`;
  }
  if (allMAMSectionsSelected.value) {
    return `${$t("all")}`;
  }
  return mamSectionSelectionList.value
    .filter((x) => x.selection)
    .map((x, index) => `${index === 0 ? "" : " "}${x.name}`)
    .toString();
});

const mamSectionsList = ref<Array<string>>([]);
const mamSectionSelectionList = ref<Array<{ name: string; selection: boolean }>>([]);

const selectAllMamSection = () => {
  for (const section of mamSectionSelectionList.value) {
    section.selection = true;
  }
};
const deselectAllMamSection = () => {
  for (const section of mamSectionSelectionList.value) {
    section.selection = false;
  }
};
//#endregion

//#region Erp-Section-Selection
const allERPSectionsSelected = computed(() => {
  return !_.some(erpSectionSelectionList.value, { selection: false, isSelectable: true });
});
const noneERPSectionsSelected = computed(() => {
  return !_.some(erpSectionSelectionList.value, { selection: true });
});

const selectedERPSectionString = computed(() => {
  if (noneERPSectionsSelected.value) {
    return `<${$t("none")}>`;
  }
  if (allERPSectionsSelected.value) {
    return `${$t("all")}`;
  }
  return erpSectionSelectionList.value
    .filter((x) => x.selection)
    .map((x, index) => `${index === 0 ? "" : " "}${x.name}`)
    .toString();
});

const erpSectionsList = ref<Array<Record<string, ERPSection>>>([]);
const erpSectionSelectionList = ref<Array<{ name: string; selection: boolean; id: string; isSelectable: boolean }>>([]);

const selectAllErpSection = () => {
  for (const section of erpSectionSelectionList.value) {
    section.selection = section.isSelectable;
  }
};
const deselectAllErpSection = () => {
  for (const section of erpSectionSelectionList.value) {
    section.selection = false;
  }
};

//#region data export type selection
const exportSelectionPermissions = ref<Record<string, boolean>>();

//#endregion

//#region LifeCycle
onMounted(async () => {
  loadData();
  window.addEventListener("beforeunload", _confirmNavigation);
});
onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", _confirmNavigation);
});
//#endregion

const _confirmNavigation: (e: Event) => boolean | undefined = function (e) {
  if (vm.hasUnsavedData) {
    e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    // Chrome requires returnValue to be set
    return (e.returnValue = "confirm" as unknown as boolean);
  }
};

//#region Export
const isIncludeUnitsEnabled = computed(() => {
  return _.some(
    vm.exportSelection,
    (item) =>
      item.selected &&
      (item.name === "GlobalAttributes" || item.name === "ErpSections" || item.name === "VariantAttributes" || item.name === "InvariantAttributes")
  );
});

const isTriggerExportDisabled = computed(() => {
  return _.filter(vm.exportSelection, (x) => x.selected)?.length == 0 && !vm.includeUnits;
});

const getFileName = () => {
  const formattedToday = moment(new Date()).format("YYYY-MM-DD kk-mm-ss");
  if (props.isAdvancedSearchExcelEdit) {
    return `${formattedToday} ${props.advancedSearchName} ExcelEdit.xlsx`;
  } else {
    const cleanedNodeName = currentNodeName.value.replace(/[!@#$%^&*+\-=[\]{};':"\\|,.<>/?]+/gi, "_");
    return `${formattedToday} ${cleanedNodeName} ExcelEdit.xlsx`;
  }
};

const triggerExport = async () => {
  resetAlerts();
  vm.isExportProgress = true;
  vm.modalShow = true;
  try {
    let excelResponse = null;
    const mamParameters = noneMAMSectionsSelected.value
      ? "None"
      : mamSectionSelectionList.value
          .filter((x) => x.selection)
          .map((x) => x.name)
          .toString();

    vm.exportIsCanceled = false;
    const formData: ExcelExportArgs = {
      catalogId: props.isAdvancedSearchExcelEdit ? (props.advancedSearchCatalogId ?? BaseIds.BaseCatalog) : catalogId.value,
      nodeId: currentNodeId.value ?? Guid.empty,
      attributegroupId: vm.selectedAttributeGroup ?? BaseIds.BaseAttributeGroup,
      language: vm.selectedLanguage ?? primaryLanguageCode.value,
      uiLanguage: userSettings.value.CurrentLocale,
      erpSectionIds: _.chain(erpSectionSelectionList.value)
        .filter((x) => x.selection)
        .map((x) => x.id)
        .value(),
      includeUnits: vm.includeUnits,
      types: _.chain(vm.exportSelection)
        .filter((x) => x.selected)
        .map((x) => x.name)
        .value()
        .toString(),
      mamParameters: vm.MAMDetails?.isMamEnabled ? mamParameters : "None"
    };

    excelResponse = !props.isAdvancedSearchExcelEdit
      ? await excelEditApi.exportExcelEdit(formData)
      : await excelEditApi.exportAdvancedSearchExcelEdit(props.advancedSearchId ?? "", formData);

    vm.warnings = excelResponse.warnings ?? {};
    if (vm.exportIsCanceled) return;

    if (!excelResponse.isSuccess) {
      vm.errors = excelResponse.message;
      return;
    } else {
      triggerFileDownloadViaEndpoint(endpoints.excelEdit.download, {
        token: excelResponse.token,
        fileName: getFileName()
      });
      vm.showExportSuccessAlert = true;
    }
    vm.modalShow = false;
  } catch (error: unknown) {
    if (error && Typeguards.isAxiosError(error)) {
      const responseData = error.response?.data;
      if (responseData) {
        if (hasBackendError409(responseData)) {
          switch (responseData.error.toLocaleLowerCase()) {
            case "invalidnode":
              vm.errors = $t("error.invalidNode").toString();
              break;
            case "invalidcatalog":
              vm.errors = $t("error.invalidCatalog").toString();
              break;
            case "attributegroupnotexist":
              vm.errors = $t("error.attributeGroupNotExist").toString();
              break;
            case "invalidoperation":
              vm.errors = $t("error.invalidOperation").toString();
              break;
            case "noarticleexistsforexport":
              vm.errors = $t("error.noArticleExistsForExport").toString();
              break;
            case "advancedsearchnotexist":
              vm.errors = $t("api.errors.AdvancedSearch.AdvancedSearchNotExist").toString();
              break;
            case "advancedsearchfailed":
              vm.errors = $t("api.errors.AdvancedSearch.AdvancedSearchFailed").toString();
              break;
            case "missingruleparameter":
              vm.errors = $t("api.errors.AdvancedSearch.MissingRuleParameter", responseData.args).toString();
              break;
            case "unknowndatalanguage":
              vm.errors = $t("api.errors.AdvancedSearch.UnknownDataLanguage", responseData.args).toString();
              break;
            case "unexpecteddatalanguage":
              vm.errors = $t("api.errors.AdvancedSearch.UnexpectedDataLanguage", responseData.args).toString();
              break;
            case "unknownattribute":
              vm.errors = $t("api.errors.AdvancedSearch.UnknownAttribute", responseData.args).toString();
              break;
            case "unknownsearchtype":
              vm.errors = $t("api.errors.AdvancedSearch.UnknownSearchType", [$t(`AdvancedSearch.SearchType.${responseData.args}`)]).toString();
              break;
            case "unknownoperatorfordatatype":
              {
                const data = AttributeDataTypes.find((type) => type.key === responseData.args[0]);
                if (data) {
                  responseData.args[0] = $t(data.name);
                }

                vm.errors = $t("api.errors.AdvancedSearch.UnknownOperatorForDataType", responseData.args).toString();
              }
              break;
            case "proceduretimedOut":
              vm.errors = $t("api.errors.AdvancedSearch.ProcedureTimedOut").toString();
              break;
            default:
              vm.modalShow = false;
              emitter.emit("global-error", { type: "api", exception: error });
              break;
          }
        } else {
          vm.modalShow = false;
          emitter.emit("global-error", { type: "api", exception: error });
        }
      } else {
        vm.modalShow = false;
        emitter.emit("global-error", { type: "api", exception: error });
      }
    }
  } finally {
    vm.exportIsCanceled = false;
  }
};

const cancelExportProgressModal = () => {
  if (vm.isExportProgress) {
    vm.exportIsCanceled = true;
  } else if (vm.abortController) {
    vm.abortController.abort(); // Cancel the import request
  }
};

const hasBackendError409 = (e: unknown): e is { message: string; value: string; error: string; args?: any } => {
  return !!e && Object.hasOwn(e, "message") && Object.hasOwn(e, "value") && Object.hasOwn(e, "error");
};

const exportWarningsKeys = computed(() => {
  return Object.keys(vm.warnings);
});

const resetAlerts = () => {
  vm.showExportSuccessAlert = false;
  vm.showImportSuccessAlert = false;
};
//#endregion

//#region File-Upload
const acceptedMimeType = ["application/vnd.ml-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-excel"];

const fileUploadInput: Ref<HTMLInputElement | undefined> = ref();

const hasCorrectFileType = computed(() => {
  return acceptedMimeType.includes(vm.uploadedFile?.type ?? "");
});

const fileDrop = (event: DragEvent) => {
  const data = event.dataTransfer?.files;
  if (data) {
    const file = data.item(0);
    if (file) {
      vm.uploadedFile = file;
    } else {
      alert($t("error.wrongFileType"));
    }
  }
  vm.isDroping = false;
};

const changeFile = (event: Event) => {
  const target: HTMLInputElement | null = <HTMLInputElement>event.target;
  const data = target?.files;
  if (data) {
    const file = data.item(0);
    if (file) {
      vm.uploadedFile = file;
    } else {
      alert($t("error.wrongFileType"));
    }
  }
};

const triggerimport = async () => {
  vm.warnings = {};
  resetAlerts();
  vm.isExportProgress = false;
  vm.modalShow = true;
  try {
    if (vm.uploadedFile) {
      vm.abortController = new AbortController();
      const excelResponse = await excelEditApi.excelImport(vm.uploadedFile, vm.abortController.signal);
      vm.warnings = excelResponse.warnings ?? {};
      const hasWarning: boolean = exportWarningsKeys.value.length > 0;
      createActivity(vm.uploadedFile.name, hasWarning, !excelResponse.isSuccess);
      if (!excelResponse.isSuccess) {
        vm.errors = excelResponse.message;
        return;
      } else {
        vm.showImportSuccessAlert = true;
        emitter.emit("refresh-catalog-tree");
        if (checkForLicensed("AutomationServer")) {
          try {
            await automationServerApi.executeAutomationsIfRequired([3, 5]); // triggertypes ArticlesModified and DataImported
          } catch (error) {
            console.error("Automation execution for the trigger type 'Articles modified and Data imported' failed with error : ", error);
          }
        }

        setTimeout(() => {
          vm.modalShow = false;
        }, 1000);
      }
    }
  } catch (error: any) {
    if (Typeguards.isAxiosError(error)) {
      if (axios.isCancel(error)) {
        eventLogger.info("ImportCancelled", "ExcelEdit import cancelled by user.");
        return;
      }

      const status = error.response?.status;

      if (status === 400) {
        const fileErrors = error.response?.data?.file;
        const errorKey = fileErrors?.[0];

        const errorMessage = errorKey ? $t("api.errors." + errorKey) : $t("UploadFailed");

        createToast({
          text: errorMessage,
          title: $t("Error"),
          variant: "danger",
          titleIcon: "Content-Editor",
          textIllustration: "Error",
          statusTextIcon: "XCircleSolid"
        });
      } else {
        const responseData = error.response?.data;

        if (responseData) {
          if (hasBackendError409(responseData)) {
            vm.errors = responseData.message;
          } else {
            vm.modalShow = false;
            emitter.emit("global-error", { type: "api", exception: error });
          }
        } else {
          vm.modalShow = false;
          emitter.emit("global-error", { type: "api", exception: error });
        }
      }
    }
  } finally {
    vm.uploadedFile = null;
  }
};
const createActivity = async (fileName: string, hasWarning: boolean, hasError: boolean) => {
  try {
    if (globalParameters.value.IsActivityFeedEnabled) {
      const criteria: ActivityCriteria = {
        severity: hasError ? "Error" : hasWarning ? "Warning" : "Information",
        process: "Import",
        objectType: "Data",
        objectValue: fileName,
        status: hasError ? "WithAtLeastOneError" : hasWarning ? "WithAtLeastOneWarning" : "Successful",
        action: hasError ? "Canceled" : hasWarning ? "Completed" : "Completed",
        applicationId: Number(apps.Modules.ContentEditor.Id),
        descriptionKey: "ExcelEditExecuted",
        descriptionValues: []
      };
      const criterias: Array<ActivityCriteria> = [criteria];
      await activityApi.createActivity(criterias);
    }
  } catch (error) {
    console.error("Activity insertion for excel edit import process failed with error : ", error);
  }
};
//#endregion

//#region Load Data
const loadData = async () => {
  try {
    await loadLanguageSpecificData();
    await loadExportSelectionTypes();
    vm.MAMDetails = await mediaAssetsApi.getMamDetails();
    if (vm.MAMDetails?.isMamEnabled) {
      mamSectionsList.value = await excelEditApi.getMamParameterTypes();

      if (userSettings.value?.ExcelEditAreas) {
        const savedMamSectionNames = JSON.parse(userSettings.value?.ExcelEditAreas)?.selectedMAMSections ?? [];
        mamSectionSelectionList.value = mamSectionsList.value
          .filter((x) => x != "None")
          .map((x) => {
            return { selection: savedMamSectionNames.includes(x), name: x };
          });
      }
    }
  } catch (error: unknown) {
    if (Typeguards.isAxiosError(error)) {
      console.error("During the Fetching of the Data occured an Error", error.message);
    }
  }
};

const loadLanguageSpecificData = async () => {
  try {
    if (props.isAdvancedSearchExcelEdit && props.advancedSearchCatalogId && props.advancedSearchId) {
      vm.attributeGroups = await excelEditApi.getAttributeGroupsOfAdvancedSearch(
        props.advancedSearchCatalogId,
        props.advancedSearchId,
        primaryLanguageCode.value
      );
    } else {
      vm.attributeGroups = await excelEditApi.getAttributeGroupsOfCatalogNode(catalogId.value, currentNodeId.value, primaryLanguageCode.value);
    }

    vm.selectedAttributeGroup = hasMultipleAttributeGroups.value ? null : vm.attributeGroups[0].attributeGroupId;
    vm.attributeGroups = naturalSort(vm.attributeGroups, "attributeGroupPath");
    vm.attributeGroups.unshift({
      attributeGroupId: null,
      attributeGroupPath: `<${$t("none")}>`
    });

    erpSectionsList.value = await erpSectionsApi.get([primaryLanguageCode.value]);
    if (userSettings.value?.ExcelEditAreas) {
      const savedErpIds = JSON.parse(userSettings.value.ExcelEditAreas)?.selectedErpSections ?? [];

      erpSectionSelectionList.value = erpSectionsList.value.map((x) => {
        return {
          name: x[primaryLanguageCode.value].name,
          id: x[primaryLanguageCode.value].erpSectionId,
          isSelectable: !(x[primaryLanguageCode.value].isReadOnly && globalParameters.value.IsErpActivated),
          selection:
            !(x[primaryLanguageCode.value].isReadOnly && globalParameters.value.IsErpActivated) &&
            savedErpIds.includes(x[primaryLanguageCode.value].erpSectionId)
        };
      });
    }
  } catch (error: unknown) {
    if (Typeguards.isAxiosError(error)) {
      console.error("During the Fetching of the Data occured an Error", error.message);
    }
  }
};

const loadExportSelectionTypes = async () => {
  try {
    const exportTypes: Record<string, boolean> = await excelEditApi.getExportDataTypes();
    exportSelectionPermissions.value = exportTypes;
    if (!exportTypes["References"]) {
      vm.exportSelection.references.selected = false;
    }
    if (!exportTypes["Prices"]) {
      vm.exportSelection.prices.selected = false;
    }
  } catch (error: unknown) {
    if (Typeguards.isAxiosError(error)) {
      console.error("During the Fetching of the Data occured an Error", error.message);
    }
  }
};

//#region save and restore user settings
const getExcelEditAreasToSave = () => {
  if (!vm.hasUnsavedData) return;
  const currentExcelEditAreas = userSettings.value.ExcelEditAreas ? JSON.parse(userSettings.value.ExcelEditAreas) : {};
  const state = {
    exportSelection: Object.fromEntries(Object.entries(vm.exportSelection).map(([key, value]) => [key, value.selected])),
    includeUnits: vm.includeUnits,
    selectedErpSections:
      erpSectionSelectionList.value.length > 0
        ? erpSectionSelectionList.value.filter((x) => x.selection).map((x) => x.id)
        : (currentExcelEditAreas.selectedErpSections ?? []),
    selectedMAMSections:
      mamSectionSelectionList.value.length > 0
        ? mamSectionSelectionList.value.filter((x) => x.selection).map((x) => x.name)
        : (currentExcelEditAreas.selectedMAMSections ?? [])
  };

  return state;
};

const restoreExcelEditAreasFromSettings = () => {
  if (!userSettings.value?.ExcelEditAreas) return;

  const parsed = JSON.parse(userSettings.value.ExcelEditAreas);
  if (parsed.exportSelection) {
    Object.entries(vm.exportSelection).forEach(([key, value]) => {
      if (parsed.exportSelection[key] !== undefined) {
        value.selected = parsed.exportSelection[key];
      }
    });
  }

  if (typeof parsed.includeUnits === "boolean") {
    vm.includeUnits = parsed.includeUnits;
  }
};
//#endregion

//#region Watchers
watch(
  () => userSettings.value,
  async (nv) => {
    if (nv) {
      restoreExcelEditAreasFromSettings();
    }
  },
  { immediate: true }
);

watch(
  () => vm.exportSelection,
  () => {
    vm.hasUnsavedData = true;
    if (!isIncludeUnitsEnabled.value) {
      vm.includeUnits = false;
    }
  },
  { deep: true }
);

watch(
  () => [vm.includeUnits, erpSectionSelectionList.value.map((x) => x.selection), mamSectionSelectionList.value.map((x) => x.selection)],
  () => {
    vm.hasUnsavedData = true;
  }
);

watch(
  () => vm.modalShow,
  () => {
    vm.errors = undefined;
  }
);

watch(
  () => userSettings.value.CurrentLocale,
  () => {
    loadLanguageSpecificData();
  }
);

__expose({ getExcelEditAreasToSave });
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_BFormCheckbox = _resolveComponent("BFormCheckbox")!
  const _component_BDropdownItem = _resolveComponent("BDropdownItem")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_BDropdownForm = _resolveComponent("BDropdownForm")!
  const _component_BDropdown = _resolveComponent("BDropdown")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_b_modal = _resolveDirective("b-modal")!

  return (vm.MAMDetails)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_unref($t)("excelEdit.language")), 1),
            _createVNode(Dropdown, {
              id: "language-dd",
              modelValue: vm.selectedLanguage,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.selectedLanguage) = $event)),
              items: languageList.value,
              textField: "name",
              valueField: "key",
              "data-cy": "excel-edit-data-languages-ddn"
            }, {
              "item-template": _withCtx(({ entry }) => [
                entry
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(entry.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "items"])
          ]),
          _hoisted_5
        ]),
        (hasMultipleAttributeGroups.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", null, _toDisplayString(_unref($t)("attributeGroup")), 1),
                _createVNode(Dropdown, {
                  items: vm.attributeGroups,
                  "text-field": "attributeGroupPath",
                  "value-field": "attributeGroupId",
                  default: `<${_unref($t)('none')}>`,
                  modelValue: vm.selectedAttributeGroup,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vm.selectedAttributeGroup) = $event)),
                  "data-cy": "excel-edit-attribute-groups-ddn"
                }, null, 8, ["items", "default", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref($t)("excelEdit.multipleAttributegroupsHint")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("strong", _hoisted_12, _toDisplayString(_unref($t)("excelEdit.exportSelectionSectionTitle")), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.masterData.selected,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((vm.exportSelection.masterData.selected) = $event)),
                  "data-cy": "excel-edit-master-data-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.masterData")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.alternativeArticleNo.selected,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((vm.exportSelection.alternativeArticleNo.selected) = $event)),
                  "data-cy": "excel-edit-alternative-artno-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.alternativeArticleNo")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.mediaAssets.selected,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((vm.exportSelection.mediaAssets.selected) = $event)),
                  "data-cy": "excel-edit-media-asset-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.mediaAssets")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.keywords.selected,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((vm.exportSelection.keywords.selected) = $event)),
                  "data-cy": "excel-edit-keywords-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.keywords")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.classification.selected,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((vm.exportSelection.classification.selected) = $event)),
                  "data-cy": "excel-edit-classification-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.classification")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.gpsr.selected,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((vm.exportSelection.gpsr.selected) = $event)),
                  "data-cy": "excel-edit-gpsr-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.gpsr")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.references.selected,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((vm.exportSelection.references.selected) = $event)),
                  disabled: exportSelectionPermissions.value && !exportSelectionPermissions.value[vm.exportSelection.references.name],
                  "data-cy": "excel-edit-references-cbx"
                }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createElementBlock("span", null, [
                      _createTextVNode(_toDisplayString(_unref($t)("excelEdit.references")), 1)
                    ])), [
                      [_directive_tooltip, 
                  exportSelectionPermissions.value && !exportSelectionPermissions.value[vm.exportSelection.references.name] && _unref($t)('excelEdit.referenceattributesFound')
                ]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.prices.selected,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((vm.exportSelection.prices.selected) = $event)),
                  disabled: exportSelectionPermissions.value && !exportSelectionPermissions.value[vm.exportSelection.prices.name],
                  "data-cy": "excel-edit-prices-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.prices")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.globalAttributes.selected,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((vm.exportSelection.globalAttributes.selected) = $event)),
                  "data-cy": "excel-edit-global-attributes-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.globalAttributes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.erpAttributes.selected,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((vm.exportSelection.erpAttributes.selected) = $event)),
                  "data-cy": "excel-edit-erp-attributes-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.erpAttributes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.textAttributes.selected,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((vm.exportSelection.textAttributes.selected) = $event)),
                  disabled: hasMultipleAttributeGroups.value && !vm.selectedAttributeGroup,
                  "data-cy": "excel-edit-text-attributes-cbx"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref($t)("excelEdit.textAttributes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"]),
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.exportSelection.tableAttributes.selected,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((vm.exportSelection.tableAttributes.selected) = $event)),
                  disabled: hasMultipleAttributeGroups.value && !vm.selectedAttributeGroup,
                  "data-cy": "excel-edit-table-attributes-cbx"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref($t)("excelEdit.tableAttributes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"]),
                _hoisted_17,
                _createVNode(_component_BFormCheckbox, {
                  modelValue: vm.includeUnits,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((vm.includeUnits) = $event)),
                  "data-cy": "excel-edit-include-units-cbx",
                  disabled: !isIncludeUnitsEnabled.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.includeUnits")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ])
            ]),
            _hoisted_18
          ])
        ]),
        (vm.exportSelection.mediaAssets.selected && vm.MAMDetails?.isMamEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", null, _toDisplayString(_unref($t)("mamSections")), 1),
                _createVNode(_component_BDropdown, {
                  class: "dropdown-default",
                  text: selectedMAMSectionString.value,
                  "auto-close": "inside",
                  "data-cy": "excel-edit-mam-sections-cbx"
                }, {
                  default: _withCtx(() => [
                    (allMAMSectionsSelected.value)
                      ? (_openBlock(), _createBlock(_component_BDropdownItem, {
                          key: 0,
                          class: "mam-section-selection-entry",
                          onClick: deselectAllMamSection
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("deselectAll")), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_BDropdownItem, {
                          key: 1,
                          class: "mam-section-selection-entry",
                          onClick: selectAllMamSection
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("selectAll")), 1)
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_BDropdownForm, { "form-class": "p-0" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mamSectionSelectionList.value, (section, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "mam-section-selection-entry hover px-3 py-1",
                            key: index
                          }, [
                            _createVNode(_component_b_form_checkbox, {
                              modelValue: section.selection,
                              "onUpdate:modelValue": ($event: any) => ((section.selection) = $event)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref($t)(`mamSection.${section.name}`)), 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["text"])
              ])
            ]))
          : _createCommentVNode("", true),
        (vm.exportSelection.erpAttributes.selected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", null, _toDisplayString(_unref($t)("erpSections")), 1),
                _createVNode(_component_b_dropdown, {
                  class: "dropdown-default",
                  text: selectedERPSectionString.value,
                  "data-cy": "excel-edit-erp-section-cbx"
                }, {
                  default: _withCtx(() => [
                    (allERPSectionsSelected.value)
                      ? (_openBlock(), _createBlock(_component_BDropdownItem, {
                          key: 0,
                          class: "erp-section-selection-entry",
                          onClick: deselectAllErpSection
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("deselectAll")), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_BDropdownItem, {
                          key: 1,
                          class: "erp-section-selection-entry",
                          onClick: selectAllErpSection
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("selectAll")), 1)
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_BDropdownForm, { "form-class": "p-0" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(erpSectionSelectionList.value, (section, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "erp-section-selection-entry hover px-3 py-1",
                            key: index
                          }, [
                            _createVNode(_component_b_form_checkbox, {
                              modelValue: section.selection,
                              "onUpdate:modelValue": ($event: any) => ((section.selection) = $event),
                              disabled: !section.isSelectable
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(section.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["text"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(Alert, {
            class: "w-100",
            show: exportWarningsKeys.value.length < 1 && vm.showExportSuccessAlert,
            dismissible: "",
            onDismissed: _cache[15] || (_cache[15] = ($event: any) => (vm.showExportSuccessAlert = false)),
            variant: "success",
            "data-cy": "excel-edit-export-success-alert",
            "with-icon": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)("excelEdit.exportSuccessfull")), 1)
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(Alert, {
            class: "w-100",
            "with-icon": "",
            show: vm.showImportSuccessAlert,
            dismissible: "",
            onDismissed: _cache[16] || (_cache[16] = ($event: any) => (vm.showImportSuccessAlert = false)),
            variant: "success",
            "data-cy": "excel-edit-import-success-alert"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)("excelEdit.importSuccessfull")), 1)
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(Alert, {
            class: "w-100",
            "with-icon": "",
            variant: "warning",
            show: exportWarningsKeys.value.length > 0
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _createTextVNode(_toDisplayString(_unref($t)("excelEdit.warnings")) + " ", 1),
                _withDirectives((_openBlock(), _createBlock(_component_b_btn, {
                  size: "sm",
                  variant: "link",
                  class: "ml-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("excelEdit.showWarnings")), 1)
                  ]),
                  _: 1
                })), [
                  [
                    _directive_b_modal,
                    void 0,
                    void 0,
                    { "warnings-overview": true }
                  ]
                ])
              ])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_b_modal, {
            "header-close-content": "",
            id: "warnings-overview",
            "ok-only": "",
            "ok-title": _unref($t)('Close'),
            title: _unref($t)('warningsOverview'),
            "body-class": "warnings-overview-modal overflow-auto"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exportWarningsKeys.value, (warningKey, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("strong", null, _toDisplayString(_unref($t)(_unref(_).camelCase(warningKey))), 1),
                  _createElementVNode("ul", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.warnings[warningKey], (entry, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "warning-entry",
                        key: index
                      }, _toDisplayString(_unref($t)(`excelEditWarnings.${_unref(_).camelCase(entry)}`)), 1))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["ok-title", "title"]),
          _createVNode(_component_b_btn, {
            variant: "primary",
            onClick: triggerExport,
            "data-cy": "excel-edit-create-output-btn",
            disabled: isTriggerExportDisabled.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)("excelEdit.startExport")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", {
            class: "drop-area",
            onDrop: _withModifiers(fileDrop, ["stop","prevent"]),
            onDragover: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (vm.isDroping = true), ["stop","prevent"])),
            onDragleave: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (vm.isDroping = false), ["stop","prevent"]))
          }, [
            (!vm.uploadedFile)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["empty-content", { 'is-dropping': vm.isDroping }]),
                  "data-cy": "excel-edit-drop-file"
                }, [
                  _withDirectives(_createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_unref($t)("dropFileNow")), 1)
                  ], 512), [
                    [_vShow, vm.isDroping]
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _hoisted_31,
                    _createElementVNode("span", _hoisted_32, [
                      _createTextVNode(_toDisplayString(_unref($t)("excelEdit.dropHint.drop")) + " " + _toDisplayString(_unref($t)("excelEdit.dropHint.orOpen")) + " ", 1),
                      _createElementVNode("a", {
                        href: "#",
                        class: "ml-1 p-0",
                        onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (fileUploadInput.value?.click()), ["prevent"]))
                      }, _toDisplayString(_unref($t)("excelEdit.dropHint.fileExplorer")), 1),
                      _createElementVNode("input", {
                        ref_key: "fileUploadInput",
                        ref: fileUploadInput,
                        type: "file",
                        onChange: changeFile,
                        hidden: "",
                        accept: acceptedMimeType.toString(),
                        "data-cy": "excel-edit-import-upload-txt"
                      }, null, 40, _hoisted_33)
                    ])
                  ], 512), [
                    [_vShow, !vm.isDroping]
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (vm.uploadedFile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    (hasCorrectFileType.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                      : (_openBlock(), _createElementBlock("i", _hoisted_37)),
                    _createElementVNode("span", _hoisted_38, _toDisplayString(vm.uploadedFile.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_b_btn, {
                      class: "mr-1",
                      variant: "primary",
                      onClick: triggerimport,
                      disabled: !hasCorrectFileType.value,
                      "data-cy": "excel-edit-transfer-data"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("excelEdit.startImport")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_b_btn, {
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (vm.uploadedFile = null))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("discardFile")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (vm.uploadedFile && !hasCorrectFileType.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref($t)("provideCorrectFile")), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 40, _hoisted_27)
        ]),
        _createVNode(ExportProgressModal, {
          "is-export": vm.isExportProgress,
          "modal-show": vm.modalShow,
          "onUpdate:modalShow": _cache[21] || (_cache[21] = ($event: any) => ((vm.modalShow) = $event)),
          errors: vm.errors,
          onCancel: cancelExportProgressModal
        }, null, 8, ["is-export", "modal-show", "errors"])
      ]))
    : (_openBlock(), _createBlock(Spinner, { key: 1 }))
}
}

})